module.exports = __webpack_public_path__ + "static/img/COC2023-8.afcf27a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-8.png
// module id = DqeV
// module chunks = 0